import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "@/lib/site";
import Logo from "@/components/Logo";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 bg-white transition-shadow ${scrolled ? "shadow-[0_1px_0_0_#D6DDD9,0_8px_24px_-18px_rgba(26,61,46,0.25)]" : "border-b border-[#D6DDD9]"}`}
    >
      <div className="eco-container flex items-center justify-between h-[80px]">
        <Link to="/" data-testid="nav-logo" className="flex items-center group">
          <Logo size={56} className="transition-transform group-hover:scale-[1.02]" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) => `eco-nav-link ${isActive ? "active" : ""}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/contact"
            data-testid="nav-cta-estimate"
            className="eco-btn eco-btn-primary"
          >
            Get a Free Estimate
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-[10px] border border-[#D6DDD9] text-[#1A1A1A]"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#D6DDD9] bg-white">
          <div className="eco-container py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-mobile-link-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-[8px] text-[15px] font-medium ${isActive ? "bg-[#F4F6F5] text-[#2D6A4F]" : "text-[#1A1A1A] hover:bg-[#F4F6F5]"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="nav-mobile-cta-estimate"
              className="eco-btn eco-btn-primary mt-2 w-full"
            >
              Get a Free Estimate
            </Link>
            <a href={SITE.phoneHref} data-testid="nav-mobile-call" className="mt-2 text-center text-[14px] text-[#555555]">
              Or call <span className="text-[#2D6A4F] font-semibold">{SITE.phone}</span>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
